module.exports = __webpack_public_path__ + "static/img/3.5eb5016.png";


//////////////////
// WEBPACK FOOTER
// ./src/public/image/05/1/3.png
// module id = Oj7n
// module chunks = 2